import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Avatar, Spin, List } from 'antd';
import { longDateFormat } from 'utils/dates';
import { useDocument } from 'react-firebase-hooks/firestore';
import moment from 'moment';
import classNames from 'classnames';

import Client from 'containers/app/client';

import './style.css';

const ConnectionRow = ({ connection, user, profile }) => {
  const { timestampCreated } = connection;
  const ref = Client.db.doc(`users/${user}`);
  const [doc, loading, error] = useDocument(ref);

  if (loading) return <Spin />;
  if (error) throw error;
  if (!doc.data()) return null;

  const { info } = doc.data();

  const dateCreated = moment(timestampCreated.toDate()).format(longDateFormat);

  const customClassName = classNames('connection-row');

  return (
    <List.Item className={customClassName}>
      <List.Item.Meta
        avatar={
          <Link to={profile}>
            <Avatar size={60} src={info.photoURL} />
          </Link>
        }
        title={`${info.firstName} ${info.lastName}`}
        description={`Connected on ${dateCreated}`}
      />
    </List.Item>
  );
};

ConnectionRow.propTypes = {
  connection: PropTypes.shape({
    timestampCreated: PropTypes.shape({
      toDate: PropTypes.func,
    }),
  }).isRequired,
  user: PropTypes.string.isRequired,
  profile: PropTypes.string.isRequired,
};

export default ConnectionRow;
